import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingReceipts: false,
  loadingReceipt: false,
  loadingPdf: false,
  loadingEmail: false,

  errorLoadingReceipts: null,
  errorLoadingReceipt: null,
  errorLoadingPdf: null,
  errorEmailing: null,

  receipts: [],
  currentReceipt: null,
  pdfUrl: null,
  pagination: null,
  serverStatus: null,
};

export const receiptSlice = createSlice({
  name: "receipt",
  initialState,
  reducers: {
    setLoadingReceipts: (state) => {
      state.loadingReceipts = true;
      state.errorLoadingReceipts = null;
    },
    setLoadingReceipt: (state) => {
      state.loadingReceipt = true;
      state.errorLoadingReceipt = null;
    },
    setLoadingPdf: (state) => {
      state.loadingPdf = true;
      state.errorLoadingPdf = null;
    },
    setLoadingEmail: (state) => {
      state.loadingEmail = true;
      state.errorEmailing = null;
    },

    setErrorLoadingReceipts: (state, { payload }) => {
      state.loadingReceipts = false;
      state.errorLoadingReceipts = payload;
    },
    setErrorLoadingReceipt: (state, { payload }) => {
      state.loadingReceipt = false;
      state.errorLoadingReceipt = payload;
    },
    setErrorLoadingPdf: (state, { payload }) => {
      state.loadingPdf = false;
      state.errorLoadingPdf = payload;
    },
    setErrorEmailing: (state, { payload }) => {
      state.loadingEmail = false;
      state.errorEmailing = payload;
    },

    setReceipts: (state, { payload: { content, pagination } }) => {
      state.loadingReceipts = false;
      state.receipts = content;
      state.pagination = pagination;
    },
    setCurrentReceipt: (state, { payload }) => {
      state.loadingReceipt = false;
      state.currentReceipt = payload;
    },

    setPdfUrl: (state, { payload }) => {
      state.loadingPdf = false;
      state.pdfUrl = payload;
    },
    clearPdfUrl: (state) => {
      if (state.pdfUrl) URL.revokeObjectURL(state.pdfUrl);
      state.pdfUrl = null;
    },
    setEmailSuccess: (state) => {
      state.loadingEmail = false;
    },

    setServerResponseStatus: (state, { payload }) => {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingReceipts,
  setLoadingReceipt,
  setLoadingPdf,
  setLoadingEmail,
  setErrorLoadingReceipts,
  setErrorLoadingReceipt,
  setErrorLoadingPdf,
  setErrorEmailing,
  setReceipts,
  setCurrentReceipt,
  setPdfUrl,
  clearPdfUrl,
  setEmailSuccess,
  setServerResponseStatus,
} = receiptSlice.actions;

export default receiptSlice.reducer;
